/*
 @flow
 @format
*/

import React from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

import './App.css';

import SessionViewComponent from './screens/SessionView';
import SessionChangeStatusComponent from './screens/SessionChangeStatus';
import createSessionPage from './screens/SessionCreate';
class App extends React.Component {
  constructor(props) {
    super(props);

    this.publisherRef = React.createRef();
  }
  
  render() {
    return (
      <div className="App">
        <Router>
          <Route path="/sess/view/:sessionId/:token" component={SessionViewComponent} />
          <Route
            path="/sess/setstatus/:sessionId/:token"
            component={SessionChangeStatusComponent}
          />
          <Route
            path="/createSession"
            component={createSessionPage}
          />
        </Router>
      </div>
    );
  }
}

export default App;
